import Vue from 'vue'
import Vuex from 'vuex'

import agreements from './agreements.module'
import auth from './auth.module'
import profile from './profile.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    agreements,
    auth,
    profile
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js